import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=d4b942d4&"
import script from "./MobileNavigation.vue?vue&type=script&lang=ts&"
export * from "./MobileNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b942d4')) {
      api.createRecord('d4b942d4', component.options)
    } else {
      api.reload('d4b942d4', component.options)
    }
    module.hot.accept("./MobileNavigation.vue?vue&type=template&id=d4b942d4&", function () {
      api.rerender('d4b942d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/navigation/MobileNavigation.vue"
export default component.exports